// extracted by mini-css-extract-plugin
module.exports = {"root":"MarkButton_root__l8QS1","active":"MarkButton_active__a4NLt"};